import {
  Checkbox as MuiCheckbox,
  FormControlLabel as MuiFormControlLabel,
} from '@mui/material';
import Accordion from 'components/Accordion';
import LoadingPage from 'components/LoadingPage';
import { Search } from 'components/ui';
import colors from 'lib/colors';
import useCareTeamsForAutocompleteRequest from 'pagesAdmin/SettingsPage/TabSubOrgs/hooks/useCareTeamsForAutocompleteRequest';
import { mergeAndSortArrays } from 'lib/utils/returnUniqueIdValues';
import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useDebounce } from 'use-debounce';
import InfiniteScroll from 'react-infinite-scroll-component';

export default function CareTeamFilter({ filters, setFilters, defaultExpanded = false }) {
  const { t } = useTranslation();

  const listContainerRef = useRef(null);
  const [search, setSearch] = useState('');
  const [debouncedSearch] = useDebounce(search, 500);
  const {
    careTeams,
    loadingCareTeams,
    loadMore,
  } = useCareTeamsForAutocompleteRequest(debouncedSearch);

  useEffect(() => {
    const handleScroll = (event) => {
      const { scrollTop, scrollHeight, clientHeight } = event.currentTarget;
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        loadMore();
      }
    };

    const listDiv = listContainerRef.current;
    if (listDiv) {
      listDiv.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (listDiv) {
        listDiv.removeEventListener('scroll', handleScroll);
      }
    };
  }, [loadMore]);

  const handleCheckboxClick = (value) => {
    const isPresent = !!filters.careTeamIds?.find(
      (item) => value.id === item.id
    );

    const updatedCareTeamsList = isPresent
      ? filters.careTeamIds?.filter((item) => value.id !== item.id)
      : [...filters.careTeamIds, value];
    setFilters((curr) => ({
      ...curr,
      careTeamIds: updatedCareTeamsList,
    }));
  };

  return (
    <Accordion title={t('Care teams')} defaultExpanded={defaultExpanded}>
      <Search
        small
        placeholder={t('Search care teams')}
        onChange={(e, v) => setSearch(e.target.value)}
      />

      <div
        ref={listContainerRef}
        style={{
          display: 'flex',
          flexDirection: 'column',
          padding: 10,
          margin: '10px 0',
          border: `1px solid ${colors.gray400}`,
          borderRadius: 6,
          maxHeight: '450px',
          overflowY: 'auto',
        }}
      >
        {loadingCareTeams ? (
          <LoadingPage style={{ width: 100, height: 100 }} />
        ) : (
          mergeAndSortArrays(filters.careTeamIds, careTeams || [], 'id')?.map?.(
            (careTeam) => {
              return (
                <MuiFormControlLabel
                  key={careTeam.id}
                  control={
                    <MuiCheckbox
                      checked={
                        !!filters.careTeamIds.find(
                          (item) => item.id === careTeam.id
                        )
                      }
                      onClick={() => handleCheckboxClick(careTeam)}
                    />
                  }
                  label={careTeam.name}
                />
              );
            }
          )
        )}
      </div>
    </Accordion>
  );
}
